export const getCleanedArticleHref = (categoryId?: string): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const currentUrl = new URL(window.location.href);
  const baseUrl = `${currentUrl.href.split('?')[0]}`;

  if (categoryId) {
    return `${baseUrl}?categoryId=${categoryId}`;
  }

  return baseUrl;
};
